var _path, _g, _path2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 54,
    viewBox: "0 0 43 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_973_712",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 33,
    width: 43,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Clip 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666687 33.6572H42.9064V53.3212H0.666687V33.6572Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_973_712)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7891 37.6563C10.4264 37.6563 4.66642 39.6083 4.66642 43.4616C4.66642 47.3496 10.4264 49.3203 21.7891 49.3203C33.1491 49.3203 38.9064 47.3683 38.9064 43.5149C38.9064 39.6269 33.1491 37.6563 21.7891 37.6563ZM21.7891 53.3212C16.5651 53.3212 0.666382 53.3212 0.666382 43.4626C0.666382 34.6732 12.7224 33.6572 21.7891 33.6572C27.0131 33.6572 42.9064 33.6572 42.9064 43.5159C42.9064 52.3052 30.8531 53.3212 21.7891 53.3212Z",
    fill: "#372FFF"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_973_712",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 29,
    height: 29
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Clip 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.62634 0.333984H35.9464V28.6503H7.62634V0.333984Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_973_712)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7891 4.13965C16.0798 4.13965 11.4344 8.78232 11.4344 14.4917C11.4158 20.1823 16.0264 24.8223 21.7118 24.8437L21.7891 26.7477V24.8437C27.4958 24.8437 32.1384 20.1983 32.1384 14.4917C32.1384 8.78232 27.4958 4.13965 21.7891 4.13965ZM21.7891 28.6494H21.7038C13.9118 28.6254 7.59976 22.2707 7.62643 14.484C7.62643 6.68403 13.9784 0.332031 21.7891 0.332031C29.5971 0.332031 35.9464 6.68403 35.9464 14.492C35.9464 22.3 29.5971 28.6494 21.7891 28.6494Z",
    fill: "#372FFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.a2efc115d5e884676e1e6f24e580b293.svg";
export { ForwardRef as ReactComponent };